module.exports = __webpack_public_path__ + "static/media/marcia news.18b7513f.png";